import http from '@/services/http';
import { customerSampleAnalysesFilters } from '@/config';
import tableHelper from '@/services/tableHelper';

const customerSampleAnalyses = {
  index(tableFilters, filterStatus, config = {}) {
    const filters = tableHelper.whereFilters(
      filterStatus,
      customerSampleAnalysesFilters
    );
    return http.request({
      method: 'get',
      url: '/customer-sample-analyses',
      params: { filter: { ...tableFilters, where: filters } },
      ...config,
    });
  },
  count(filterStatus, config = {}) {
    const where = tableHelper.whereFilters(
      filterStatus,
      customerSampleAnalysesFilters
    );
    return http.request({
      method: 'get',
      url: '/customer-sample-analyses/count',
      params: { where },
      ...config,
    });
  },
  bulkUpdate(sampleAnalysisIds, locationId) {
    return http.request({
      method: 'patch',
      url: '/customer-sample-analyses/location',
      params: {
        sampleAnalysisIds,
      },
      data: {
        locationId,
      },
    });
  },
};

export default customerSampleAnalyses;
